import { EXPERIENCE } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const Experience = () => (
  <section id="experience" data-testid="clinical-experience-timeline" className="py-20 sm:py-28 bg-white/60 border-y border-[#0D3B3E]/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading number="02" title="Clinical Experience" testId="clinical-experience-heading" />
      <div>
        {EXPERIENCE.map((row, i) => (
          <Reveal key={row.org} delay={i * 0.05}>
            <div
              data-testid={`experience-timeline-row-${i}`}
              className="group grid md:grid-cols-12 gap-2 md:gap-6 items-baseline py-6 sm:py-7 border-t border-[#0D3B3E]/10 last:border-b hover:bg-[#0D9488]/[0.04] transition-colors duration-300 px-2 sm:px-4 -mx-2 sm:-mx-4"
            >
              <p className="md:col-span-2 text-[11px] font-mono tracking-[0.15em] text-[#0D9488]">{row.years}</p>
              <p className="md:col-span-4 font-display font-semibold text-lg sm:text-xl text-[#0D3B3E] leading-snug">
                {row.org}
              </p>
              <p className="md:col-span-4 text-sm text-slate-600 leading-relaxed">{row.role}</p>
              <p className="md:col-span-2 md:text-right">
                <span className="inline-block text-[9px] font-mono tracking-[0.2em] text-slate-500 border border-[#0D3B3E]/15 rounded-full px-2.5 py-1 group-hover:border-[#0D9488]/50 group-hover:text-[#0D9488] transition-colors duration-300">
                  {row.type}
                </span>
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
